import React, { createContext, useContext, useMemo } from "react";
import { useEffect, useState } from "react";
import { Dialog, Field, Form, Input, Select } from '@alifd/next';
import { ExclamationCircleFilled } from '@ant-design/icons';
//@ts-ignore
import $i18n from '@/i18n';

interface DialogProps {
  type: 'remove' | 'add';
  title: string;
  content: string;
  onOk: () => Promise<void>;
}
export const useDialog = () => {
  const [open, setOpen] = useState<DialogProps | undefined>(undefined);
  let dialogInstalce: any = null

  const close = () => {
    setOpen(undefined)
    dialogInstalce.hide()
  }

  useEffect(() => {
    if (open) {
      Dialog.show({
        v2: true,
        width: 465,
        centered: true,
        hasMask: false,
        footerActions: ['cancel', 'ok'],
        title: <div> {open.type === 'remove' && <ExclamationCircleFilled style={{ color: "#C82727", marginRight: 8 }} />}{open.title}</div>,
        content: <div style={{ marginBottom: 40 }}>{open.content}</div>,
        onOk: open.onOk,
        onClose: close,
      })
    }

  }, [open])
  return {
    openDialog: setOpen,
    closeDialog: close,
  };
};



interface customerDialogProps {
  title: string;
  osDataSource: any[]
  onOk: (field: Field | undefined) => Promise<void>;
}

const systemDataSource = [
  {
    label: 'IOS',
    value: 'IOS',
  },
  {
    label: 'Android',
    value: 'Android',
  },
];




const nameRule = {
  name: 'jsapiName',
  label: $i18n.get({ id: "aopf.pages.channel.jsApiAuth.jsapiTable.column.jsapiName", dm: "名称" }),
  placeholder: $i18n.get({ id: "aopf.pages.channel.jsApiAuth.jsapiTable.dialog.register.namePattern", dm: "支持英文大小写，支持特殊字符 \".\"，不超过100个字符" }),
  required: true,
  requiredMessage: $i18n.get({ id: "aopf.pages.channel.jsApiAuth.jsapiTable.dialog.register.nameRequired", dm: "请输入名称" }),
  maxLength: 100,
  pattern: /^(?!.*\.\.)(?!^\.)[a-zA-Z][a-zA-Z.]{0,98}[a-zA-Z]$/,
  patternMessage: $i18n.get({ id: "aopf.pages.channel.jsApiAuth.jsapiTable.dialog.register.namePattern", dm: "支持英文大小写，支持特殊字符 \".\"，不超过100个字符" }),
  patternTrigger: "onBlur",
}
const funcDescRule = {
  name: 'functionDesc',
  label: $i18n.get({ id: "aopf.pages.channel.jsApiAuth.jsapiTable.column.functionDesc", dm: "描述" }),
  placeholder: $i18n.get({ id: "aopf.pages.channel.jsApiAuth.jsapiTable.dialog.register.funcDescPlaceholder", dm: "输入2-400个字符的描述" }),
  required: true,
  maxLength: 400,
  minLength: 2,
  maxLengthMessage: $i18n.get({ id: "aopf.pages.channel.jsApiAuth.jsapiTable.dialog.register.funcDescPlaceholder", dm: "输入2-400个字符的描述" }),
  minLengthMessage: $i18n.get({ id: "aopf.pages.channel.jsApiAuth.jsapiTable.dialog.register.funcDescPlaceholder", dm: "输入2-400个字符的描述" }),
  requiredMessage: $i18n.get({ id: "aopf.pages.channel.jsApiAuth.jsapiTable.dialog.register.funcDescRequired", dm: "请输入描述" }),
}

const supportSysRule = {
  name: 'supportSystem',
  label: $i18n.get({ id: "aopf.pages.channel.jsApiAuth.jsapiTable.column.supportSystem", dm: "支持的系统" }),
  required: true,
  requiredMessage: $i18n.get({ id: "aopf.pages.channel.jsApiAuth.jsapiTable.dialog.register.supportSysRequired", dm: "请选择支持的系统" }),
  placeholder: $i18n.get({ id: "aopf.pages.channel.jsApiAuth.jsapiTable.dialog.register.selectPlaceholder", dm: "请选择" }),
}


const tagStyleVar = {
  "--tag-closable-primary-fill-bg-color": "#F1F2F3",
  "--tag-closable-primary-fill-bg-color-hover": "#e2e4e8",
  "--tag-closable-primary-fill-text-color": "#474A52",
  "--tag-closable-primary-fill-text-color-hover": "#474A52",
  "--tag-corner-radius": "2px",
  "--tag-fill-tail-color": "#666"
}
export const useAddCustomerJsApiDialog = () => {
  const [open, setOpen] = useState<customerDialogProps | undefined>(undefined);
  let globalField: Field | undefined = undefined

  let dialogInstalce: any = null

  const close = () => {
    setOpen(undefined)
    dialogInstalce.hide()
  }

  const Content = () => {
    const field = Field.useField()
    globalField = field
    return <Form field={field} labelAlign="top">
      <Form.Item {...nameRule} >
        <Input placeholder={nameRule.placeholder} />
      </Form.Item>
      <Form.Item {...funcDescRule}>
        <Input.TextArea placeholder={funcDescRule.placeholder} {...{
          maxLength: funcDescRule.maxLength,
          minLength: funcDescRule.minLength,
          hasLimitHint: true,
          showLimitHint: true,
        }} />
      </Form.Item>
      <Form.Item {...supportSysRule}>
        <Select dataSource={systemDataSource} mode="multiple" style={{ width: '100%', ...tagStyleVar }} placeholder={supportSysRule.placeholder} hasClear />
      </Form.Item>
    </Form>
  }
  useEffect(() => {

    const onOk = async (): Promise<any> => {
      try {
        const result = await globalField?.validatePromise()
        if (result?.errors) {
          console.log(result.errors)
          return Promise.resolve(false)
        } else {
          return open?.onOk(globalField)
        }
      } catch (error) {
        console.log(error)
        return Promise.resolve(false)
      }
    }
    if (open) {
      dialogInstalce = Dialog.show({

        v2: true,
        width: 640,
        height: 580,
        centered: true,
        hasMask: false,
        footerActions: ['cancel', 'ok'],
        title: <div>{open.title}</div>,
        content: <div style={{ marginBottom: 40 }}>
          <Content />
        </div>,
        onOk,
        onClose: () => setOpen(undefined),
      })
    }

    return () => {

    };

  }, [open])

  return {
    openJsApiCustomerDialog: setOpen,
    closeDialog: close,
  };

}